/**
 * 系统参数api
 */
import { coreAxios } from "@/declare/api/axios"
import { Param } from "@/declare/interface/system-lib/param"
import { ParamFormula, RsFormulaParam } from "@/declare/interface/system-lib/param-formula"
import { ParamGroup } from "@/declare/interface/system-lib/param-group"
import { AxiosResponse } from "axios"

/**
 * api前缀
 */
const urlPrefix = '/system-lib'

/**
 * 添加参数组
 * @param group 参数组
 * @return
 */
export function addParamGroup(group: ParamGroup, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`${urlPrefix}/param-groups`, group, {
        params: {
            ...params,
        }
    })
}

/**
 * 添加参数
 * @param groupUuid 参数组uuid 
 * @param param 参数对象
 * @param params 
 * @returns 
 */
export function addParam(groupUuid: string, param: Param, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`${urlPrefix}/param-groups/${groupUuid}/params`, param, {
        params: {
            ...params,
        }
    })
}

/**
 * 添加公式
 * @param paramUuid 参数uuid 
 * @param paramFormula 参数公式对象
 * @param params 
 * @returns 
 */
export function addParamFormula(paramUuid: string, paramFormula: ParamFormula, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`${urlPrefix}/param/${paramUuid}/param-formula`, paramFormula, {
        params: {
            ...params,
        }
    })
}



/**
 * 删除参数组
 * @param groupUuid 
 * @param params 
 * @returns 
 */
export function deleteParamGroup(groupUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`${urlPrefix}/param-groups/${groupUuid}`, {
        params: {
            ...params,
        }
    })
}


/**
 * 删除参数
 * @param paramUuid 
 * @param params 
 * @returns 
 */
export function deleteParam(paramUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`${urlPrefix}/params/${paramUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除公式
 * @param paramFormulaUuid 
 * @param params 
 * @returns 
 */
export function deleteParamFormula(paramFormulaUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`${urlPrefix}/param-formulas/${paramFormulaUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 修改参数组
 * @param groupUuid 
 * @param group
 * @param params 
 * @returns 
 */
export function updateParamGroup(groupUuid: string, group: ParamGroup, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`${urlPrefix}/param-groups/${groupUuid}`, group, {
        params: {
            ...params,
        }
    })
}

/**
 * 修改参数
 * @param paramUuid 
 * @param param
 * @param params 
 * @returns 
 */
export function updateParam(paramUuid: string, param: Param, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`${urlPrefix}/params/${paramUuid}`, param, {
        params: {
            ...params,
        }
    })
}

/**
 * 修改公式
 * @param paramUuid 
 * @param param
 * @param params 
 * @returns 
 */
export function updateParamFormula(paramFormulaUuid: string, paramFormula: ParamFormula, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`${urlPrefix}/param-formulas/${paramFormulaUuid}`, paramFormula, {
        params: {
            ...params,
        }
    })
}


/**
 * 更新引用参数关系（先删后添加）
 * @param paramUuid 
 * @param rsParamUuidList 引用关系的uuid组成的列表
 * @param params 
 * @returns 
 */
export function updateRsFormulaParam(formulaUuid: string, rsList: RsFormulaParam[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`${urlPrefix}/formulas/${formulaUuid}/rs-params`, rsList, {
        params: {
            ...params,
        }
    })
}


/**
 * 类型查找有层级的参数组与参数的树
 * @param type
 * @param params
 * @returns 
 */
export function findGroupMapListByType(type: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`${urlPrefix}/types/${type}/param-groups`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取参数详情
 * @param type
 * @param params
 * @returns 
 */
export function findParamDetailByUuid(paramUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`${urlPrefix}/params/${paramUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 根据公式uuid获取公式详情
 * @param formulaUuid 
 * @param params 
 * @returns 
 */
export function findParamFormulaByUuid(formulaUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`${urlPrefix}/param-formulas/${formulaUuid}`, {
        params: {
            ...params,
        }
    })
}



/**
 * 测试公式正确性
 * @param formulaUuid 
 * @param params 
 * @returns 
 */
export function formulaTest(paramFormulaId: string, args: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`${urlPrefix}/param-formulas/${paramFormulaId}/test`, args, {
        params: {
            ...params,
        }
    })
}

/**
 * 更新单个rs
 * @param formulaUuid 
 * @param paramUuid 
 * @param value 
 * @param rsOrder 
 * @param params 
 * @returns 
 */
export function updateSingleRsFormulaParam(formulaUuid: string, paramUuid: string, value: string, rsOrder?: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`${urlPrefix}/formulas/${formulaUuid}/rs-param-order`, null, {
        params: {
            paramUuid: paramUuid,
            value: value,
            rsOrder: rsOrder,
            ...params,
        }
    })
}